var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTolia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1293 -1336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    transform: "translate(1293 1336)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1293.246 1269.277)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.339,68.166a.575.575,0,0,0-.814,0L3.632,75.06.982,72.41a.575.575,0,0,0-.814.814L3.225,76.28a.576.576,0,0,0,.814,0l7.3-7.3A.575.575,0,0,0,11.339,68.166Z",
    transform: "translate(0 -67.997)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTolia);
export default __webpack_public_path__ + "static/media/tolia.190877d3b26f6835b834036530cbecf4.svg";
export { ForwardRef as ReactComponent };